import { Switch } from '@headlessui/react';

interface ReflectionNoteProps {
  reflectOnAll: boolean;
  setReflectOnAll: React.Dispatch<React.SetStateAction<boolean>>;
  isEditMode: boolean;
}

const ReflectionNote: React.FC<ReflectionNoteProps> = ({
  reflectOnAll,
  setReflectOnAll,
  isEditMode,
}) => {
  return (
    <div className="my-6 rounded-r border-l-4 border-brand-fire-400 bg-brand-fire-50 p-4">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-color-brand-primary">
            {isEditMode
              ? 'Would you like to apply the same recap updates to all participants in this lesson?'
              : 'Would you like to send this apply to all participants in this lesson?'}
          </p>
          <p className="mt-1 text-xs text-color-brand-primary">
            {isEditMode
              ? 'This will update the recap for all the participants.'
              : 'This will send the same recap to all the participants.'}
          </p>
        </div>
        <Switch
          checked={reflectOnAll}
          onChange={setReflectOnAll}
          className={`${
            reflectOnAll ? 'bg-brand-fire-500' : 'bg-gray-200'
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-brand-fire-400 focus:ring-offset-2`}
        >
          <span className="sr-only">Apply to all participants</span>
          <span
            className={`${
              reflectOnAll ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      </div>
    </div>
  );
};

export default ReflectionNote;
